import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const getDefaultState = () => ({
  currentUser: null,
  userPreferences: { },
});

const initialState = getDefaultState();

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    SET_CURRENT_USER(state, user) {
      state.currentUser = user;
    },
  },
  actions: {
    async SET_CURRENT_USER(store, user) {
      store.commit('SET_CURRENT_USER', user);
    },
  },
  getters: {
    getCurrentUser(state) {
      return state.currentUser;
    },
  },
};
